import PropTypes from "prop-types";

import {
  summaryInfoContentCss,
  wordLinkCss,
  textScoreCss,
} from "./PowerWordSummaryInfo.styles";

const propTypes = {
  correctAnswerCount: PropTypes.number,
  totalQuestionsCount: PropTypes.number,
  points: PropTypes.number,
};

const PowerWordSummaryInfo = ({
  correctAnswerCount = 0,
  totalQuestionsCount = 0,
  points = 0,
}) => {
  const ONE_POINT = 1;

  const handleSingularPluralPointWord = () =>
    points === ONE_POINT ? "point" : "points";

  return (
    <div css={summaryInfoContentCss}>
      <a css={wordLinkCss} href="/student-binder/word-wall">
        See your word wall
      </a>
      <span css={textScoreCss}>
        Scored {correctAnswerCount}/{totalQuestionsCount} and earned {points}{" "}
        {handleSingularPluralPointWord()}
      </span>
    </div>
  );
};

PowerWordSummaryInfo.propTypes = propTypes;
export default PowerWordSummaryInfo;
